module.exports = __webpack_public_path__ + "assets/img/add.dec42a6f.png";